import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FAQSection, { faqs } from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function WestminsterPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Westminster"
        state="Colorado"
        stateAbbr="CO"
        route="/westminster-co"
        title="Emergency Passport Westminster, CO — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Westminster, CO — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving north Denver metro families, tech professionals, and students near DIA."
        geoPlacename="Westminster, Colorado"
        geoPosition="39.8367;-105.0372"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Colorado"
        statePageRoute="/states/colorado"
      />
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <HowItWorksSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/westminster-co" state="CO" />
      <FinalCTA />
    </div>
  );
}